import React from 'react';

const SectionHeading = (props) => (
    <h2 className={`u-textColorDarkest u-fontSize42 u-fontWeightMedium u-phone-fontSize28 u-lineEffect u-inlineBlock u-relative`}>{props.children}</h2>
);

export default SectionHeading;